import { projectClient } from '../../client/client';

export const project = {
  get: projectClient('/project').get,
  update: projectClient('/project').patch,
};
